import { SetupContext } from '@vue/composition-api';
import _ from 'lodash';
import moment from 'moment';
import { mathjax } from 'mathjax-full/js/mathjax.js';
import { TeX } from 'mathjax-full/js/input/tex.js';
import { SVG } from 'mathjax-full/js/output/svg.js';
import { liteAdaptor } from 'mathjax-full/js/adaptors/liteAdaptor.js';
import { RegisterHTMLHandler } from 'mathjax-full/js/handlers/html.js';
import { AllPackages  } from 'mathjax-full/js/input/tex/AllPackages.js';

/***************************
 * userの権限
 ***************************/
export enum RoleEnum {
  Admin = "admin",
  Teacher1 = "teacher1",
  Teacher2 = "teacher2",
  Student = "student",
  DataTransfer = "data_transfer"
}

export enum RoleNameEnum {
  Admin = "システム管理者",
  Teacher1 = "管理者",
  Teacher2 = "一般",
  Student = "生徒",
  DataTransfer = "データ連携",
}

export interface ComboboxRole {
  value: string
  text: string
}

// プルダウン・ラジオボタン用 AdminとStudentは使用しない
export function GetComboboxRoleArray() :ComboboxRole[]{
  const rtn: ComboboxRole[] = [];
  rtn.push({value: RoleEnum.Teacher1, text: RoleNameEnum.Teacher1});
  rtn.push({value: RoleEnum.Teacher2, text: RoleNameEnum.Teacher2});
  return rtn;
}

/***************************
 * 学年
 ***************************/
export enum GradeEnum {
  Ko1 = 1,
  Ko2 = 2,
  Ko3 = 3,
}

export enum GradeNameEnum {
  Ko1 = "高1",
  Ko2 = "高2",
  Ko3 = "高3",
}

export interface ComoboxGrade {
  value: number
  text: string
}

export function GetComboboxGradeArray() :ComoboxGrade[] {
  const rtn: ComoboxGrade[] = [];
  rtn.push({value: GradeEnum.Ko1, text: GradeNameEnum.Ko1});
  rtn.push({value: GradeEnum.Ko2, text: GradeNameEnum.Ko2});
  rtn.push({value: GradeEnum.Ko3, text: GradeNameEnum.Ko3});
  return rtn;
}

export function GetGradeNameByGrade(grade: number) :string {
if(grade == GradeEnum.Ko1){
    return GradeNameEnum.Ko1;
  }else if(grade == GradeEnum.Ko2){
    return GradeNameEnum.Ko2;
  }else if(grade == GradeEnum.Ko3){
    return GradeNameEnum.Ko3;
  }else{
    return "";
  }
}

/***************************
 * 在校状態
 ***************************/
export enum StudentStatusEnum {
  Zaikou = 1,
  Kyuugaku = 2,
}

export enum StudentStatusNameEnum {
  Zaikou = "在校",
  Kyuugaku = "休学",
}

export interface ComoboxStudentStatus {
  value: number
  text: string
}

export function GetComboboxStudentStatusArray() :ComoboxGrade[] {
  const rtn: ComoboxStudentStatus[] = [];
  rtn.push({value: StudentStatusEnum.Zaikou, text: StudentStatusNameEnum.Zaikou});
  rtn.push({value: StudentStatusEnum.Kyuugaku, text: StudentStatusNameEnum.Kyuugaku});
  return rtn;
}

export function getStudentStatusNameByValue(code: number) :string {
if(code == StudentStatusEnum.Zaikou){
    return StudentStatusNameEnum.Zaikou;
  }else if(code == StudentStatusEnum.Kyuugaku){
    return StudentStatusNameEnum.Kyuugaku;
  }else{
    return "";
  }
}

/***************************
 * 実施月 プルダウン用
 ***************************/
export interface ComoboxMonth {
  value: number
  text: string
}

export function GetComboboxMonthArray() :ComoboxMonth[] {
  const rtn: ComoboxMonth[] = [];
  rtn.push({value: 1, text: "1月"});
  rtn.push({value: 2, text: "2月"});
  rtn.push({value: 3, text: "3月"});
  rtn.push({value: 4, text: "4月"});
  rtn.push({value: 5, text: "5月"});
  rtn.push({value: 6, text: "6月"});
  rtn.push({value: 7, text: "7月"});
  rtn.push({value: 8, text: "8月"});
  rtn.push({value: 9, text: "9月"});
  rtn.push({value: 10, text: "10月"});
  rtn.push({value: 11, text: "11月"});
  rtn.push({value: 12, text: "12月"});
  return rtn;
}

/***************************
 * sheet_field.kind Enum
 * api側のConstantsと同じ定義にすること
 ***************************/
export enum SheetFieldKindEnum {
  FIELD = 0,
  TOTAL_SCORE = 10,
  PART1 = 11,
  VIEW_POINT = 12,
  STUDENT_INFO = 9,
  QR_CODE = 20,
}

/***************************
 * field_activities.correct_state
 ***************************/
export const CorrectStateEnum = Object.freeze({
  Seitou: 1, 
  Gotou: -1, 
  Tokuten: 0, 
  Pending: -2,
});

export const StudentSheetStatusEnum = Object.freeze({
  Answering: 1,
  SelfScoring: 2,
  Scoring: 3,
  Failure: 4,
  Pass: 5,
});

export const MovieContentStatusEnum = Object.freeze({
  Registered: "registered",
  Zipped: "zipped",
  TransferCompleted: "transfer_completed",
});

/***************************
 * sheet_field.scoring_type Enum
 * api側のConstantsと同じ定義にすること
 ***************************/
 export enum ScoringTypeEnum {
  Seigo = 1,
  ScoreStampPlus = 2,
  ScoreStampMinus = 3,
}

/***************************
 * scoring_type プルダウン用
 ***************************/
 export interface ComoboxScoingType {
  value: number
  text: string
}

export function GetComboboxScoingTypeArray() :ComoboxScoingType[] {
  const rtn: ComoboxScoingType[] = [];
  rtn.push({value: ScoringTypeEnum.Seigo, text: GetScoringTypeNameByCode(ScoringTypeEnum.Seigo)});
  rtn.push({value: ScoringTypeEnum.ScoreStampPlus, text: GetScoringTypeNameByCode(ScoringTypeEnum.ScoreStampPlus)});
  rtn.push({value: ScoringTypeEnum.ScoreStampMinus, text: GetScoringTypeNameByCode(ScoringTypeEnum.ScoreStampMinus)});
  return rtn;
}

export function IsScoringTypeScoreStamp(scoring_type: number) :boolean {
  return scoring_type == ScoringTypeEnum.ScoreStampPlus || scoring_type == ScoringTypeEnum.ScoreStampMinus
}

export function GetScoringTypeNameByCode(code: number){
  let rtn = "";
  if(code == ScoringTypeEnum.Seigo){
    rtn = "正誤";
  }else if(code == ScoringTypeEnum.ScoreStampPlus){
    rtn = "加点方式";
  }else if(code == ScoringTypeEnum.ScoreStampMinus){
    rtn = "減点方式";
  }
  return rtn;
}

/***************************
 * 正答 プルダウン用
 ***************************/
 export interface ComoboxCorrectText {
  value: string
  text: string
}

export function GetComboboxCorrectTextArray() :ComoboxCorrectText[] {
  const rtn: ComoboxCorrectText[] = [];
  rtn.push({value: "ア", text: "ア"});
  rtn.push({value: "イ", text: "イ"});
  rtn.push({value: "ウ", text: "ウ"});
  rtn.push({value: "エ", text: "エ"});
  rtn.push({value: "オ", text: "オ"});
  rtn.push({value: "カ", text: "カ"});
  rtn.push({value: "キ", text: "キ"});
  rtn.push({value: "ク", text: "ク"});
  rtn.push({value: "ケ", text: "ケ"});
  rtn.push({value: "コ", text: "コ"});
  rtn.push({value: "0", text: "0"});
  rtn.push({value: "1", text: "1"});
  rtn.push({value: "2", text: "2"});
  rtn.push({value: "3", text: "3"});
  rtn.push({value: "4", text: "4"});
  rtn.push({value: "5", text: "5"});
  rtn.push({value: "6", text: "6"});
  rtn.push({value: "7", text: "7"});
  rtn.push({value: "8", text: "8"});
  rtn.push({value: "9", text: "9"});
  return rtn;
}

/***************************
 * アンケート回答方法
 ***************************/

export enum QuestionnaireAnswerTypeEnum {
  SingleChoice = 1,
  MultiChoice = 2,
  FreeText = 3,
  Rating = 4,
  Ranking = 5,
}

export interface ComboboxQuestionnaireAnswerType {
  value: number;
  text: string;
}

export function getComboboxQuestionnaireAnswerTypeArray(): ComboboxQuestionnaireAnswerType[] {
  const result: ComboboxQuestionnaireAnswerType[] = [];

  result.push({ value: QuestionnaireAnswerTypeEnum.SingleChoice, text: "単一選択" });
  result.push({ value: QuestionnaireAnswerTypeEnum.MultiChoice, text: "複数選択" });
  result.push({ value: QuestionnaireAnswerTypeEnum.FreeText, text: "テキスト" });
  result.push({ value: QuestionnaireAnswerTypeEnum.Rating, text: "評価" });
  result.push({ value: QuestionnaireAnswerTypeEnum.Ranking, text: "順位付け" });

  return result;
}

export function getQuestionnaireAnswerTypeNameByCode(code: number): string {
  switch (code) {
    case QuestionnaireAnswerTypeEnum.SingleChoice:
      return "単一選択";
    case QuestionnaireAnswerTypeEnum.MultiChoice:
      return "複数選択";
    case QuestionnaireAnswerTypeEnum.FreeText:
      return "テキスト";
    case QuestionnaireAnswerTypeEnum.Rating:
      return "評価";
    case QuestionnaireAnswerTypeEnum.Ranking:
      return "順位付け";
    default:
      return "";
  }
}

/***************************
 * スタンプ種別
 ***************************/
export enum StmapTypeEnum {
  Text = 1,
  Image = 2,
  Score = 3,
}

/***************************
 * API Getのクエリ生成
 ***************************/
export function BuildQuery(object: any, namespace: string) :string {
  return _.map(object, (value: any, key: any) => {
    return namespace ? `${namespace}[${encodeURIComponent(key)}]=${value == null ? '' : encodeURIComponent(value)}` : `${encodeURIComponent(key)}=${value == null ? '' : encodeURIComponent(value)}`;
  }).join('&');
}

/***************************
 * 時刻を指定されたフォーマットに変換
 ***************************/
export function formatDate(value: any, format: string) :string {
  if (value === null || value === "") {
    return "";
  }
  var datetimeAt = new Date(value);
  return moment(datetimeAt).format(format);
}

/***************************
 * 本日日付から年度を取得
 ***************************/
export const getNendo = () => {
  const date = new Date();
  date.setMonth(date.getMonth() - 3);
  return date.getFullYear();  
}

/***************************
 * 数字配列の合計値を取得
 ***************************/
export function sumArray(array: number[]) {
  let sum = 0;
  for (let i = 0, len = array.length; i < len; i++) {
    sum += array[i];
  }
  return sum;
}

/***************************
 * レポート一覧のページあたりの行数
 ***************************/
export const SheetListRowCount = 20;

/***************************
 * 学校ごとに付与されるオプション情報
 ***************************/
export enum SchoolOptionEnum {
  StudentManage = 1,
  Cbt = 2,
  Entrance = 3,
  TwoFactor = 4,
  Classroom = 5,
  DigitalPaper = 6,
  MailReturn = 7,
  Practice = 8,
  Lesson = 9,
  Report = 10,
  ApprovalExam = 11,
  DataTransfer = 12,
  StudentSubjectReport = 13,
  AllowSubmitOverLimit = 14,
  DoubleSideScan = 15,
  Movie = 16,
  AllowEditStudentSubjectReport = 20,
  CopyFailedReportAnswers = 21,
  TeacherSso = 22,
  HidePastReports = 23,
  HideScoredUserName = 24,
  ExamResultWebView = 25,
  ExamManualPublish = 26,
}

export enum SheetTypeEnum {
  Report = 1,
  LessonKyouzai = 2,
  LessonTest = 3,
  ApprovalExam = 4,
  ApprovalExamSupplementary = 5,
}

/***************************
 * 試験・追試験の帳票種別判定
 ***************************/
export function isApprovalExamSheetType(sheetType: number | string | null | undefined): boolean {
  return [SheetTypeEnum.ApprovalExam, SheetTypeEnum.ApprovalExamSupplementary].includes(Number(sheetType));
}

/***************************
 * 帳票種別名を取得
 ***************************/
export function getSheetTypeName(sheetType: number): string {
  if(sheetType == SheetTypeEnum.Report){
    return "レポート";
  }else if(sheetType == SheetTypeEnum.LessonKyouzai){
    return "講座教材";
  }else if(sheetType == SheetTypeEnum.LessonTest){
    return "講座テスト";
  }else if(sheetType == SheetTypeEnum.ApprovalExam){
    return "試験";
  }else if(sheetType == SheetTypeEnum.ApprovalExamSupplementary){
    return "追試験";
  }
  return "";
}

/***************************
 * 受講レポート回次を一覧表示用の物理回次へ変換
 ***************************/
export function getStudentSubjectReportDisplayNo(reportNo: number): number {
  if(reportNo >= 101 && reportNo <= 150){
    return reportNo - 100;
  }else if(reportNo >= 151 && reportNo <= 200){
    return reportNo - 150;
  }
  return reportNo;
}

export function createComboboxOptions(targetArray: any[], valueKey: string, textKey: string, allowEmpty: boolean){
  const options: any[] = [];
  if(allowEmpty){
    options.push({value: null, text: "-"});
  }

  targetArray.forEach(x => options.push({value: x[valueKey], text: x[textKey]}));
  
  return options;
}

/***************************
 * スクロール
 ***************************/
export function smoothScroll(fromTop: number, toTop: number, fromLeft: number, toLeft: number, elem: HTMLElement): Promise<void> {
  const duration = 300; // アニメーションの時間（ミリ秒）
  const framesPerSecond = 60; // 1秒あたりのフレーム数
  const frameInterval = 1000 / framesPerSecond; // フレームの間隔（ミリ秒）

  let scrollLeft = fromLeft;
  let scrollTop = fromTop;

  const rangeH = (toTop - fromTop) / (duration / frameInterval);
  const rangeV = (toLeft - fromLeft) / (duration / frameInterval);

  return new Promise<void>(resolve => {
    const move = function () {
      if ((rangeH > 0 && scrollTop + rangeH > toTop) || (rangeH < 0 && scrollTop + rangeH < toTop)) {
        scrollTop = toTop;
      } else {
        scrollTop += rangeH;
      }

      if ((rangeV > 0 && scrollLeft + rangeV > toLeft) || (rangeV < 0 && scrollLeft + rangeV < toLeft)) {
        scrollLeft = toLeft;
      } else {
        scrollLeft += rangeV;
      }

      // スクロールさせる
      elem.scrollTo(scrollLeft, scrollTop);

      // 現在位置が目的位置より進んでいなければアニメーションを続行させる
      if ((rangeH > 0 && scrollTop < toTop) || (rangeH < 0 && scrollTop > toTop) || (rangeV > 0 && scrollLeft < toLeft) || (rangeV < 0 && scrollLeft > toLeft)) {
        setTimeout(move, frameInterval);
      } else {
        resolve();
      }
    };
    move(); // 初回呼び出し
  });
}

/**
 * 整数チェック
 * @param value 
 */
export const isInteger = (value: string): boolean => {

  if (!value) {
    return false;
  }

  const number = Number(value);

  return !isNaN(number) && isFinite(number) && (value.toString().length == parseInt(value).toString().length) && (value.toString().indexOf(".") == -1);
}

/************************************************************
 * テキスト画像サイズ取得時に使用する定数
 ************************************************************/

export const lineScale = 1.1618;

export type GetTextSizeOptions = {
  text?: string;
  fontSize: number;
  lineHeight?: number;
  letterSpacing?: number;
  direction?: number;
  defaultText?: string;
  fontFamily?: string;
};

/************************************************************
 * テキストサイズ取得
 ************************************************************/

export const getTextSize = ({
  text = null,
  fontSize,
  lineHeight = 0,
  direction = DirectionEnum.Horizon,
  defaultText = "テキスト",
  fontFamily = "serif",
}: GetTextSizeOptions) => {
  text = text ? text : defaultText;
  let size = null;
  if(direction == DirectionEnum.Horizon){
    size = getTextSizeHorizon({text: text, fontSize: fontSize, lineHeight: lineHeight, fontFamily: fontFamily});
  }else if(direction == DirectionEnum.Vertical){
    size = getTextSizeVertical({text: text, fontSize: fontSize, lineHeight: lineHeight, fontFamily: fontFamily});
  }
  return size;
}

/************************************************************
 * 横書きテキスト画像のサイズ取得
 ************************************************************/

 export const getTextSizeHorizon = ({
  text,
  fontSize,
  lineHeight,
  fontFamily = "serif",
}: GetTextSizeOptions) => {
  const canvas = document.createElement('canvas') as HTMLCanvasElement;
  const ctx = canvas.getContext('2d');
  ctx.font = `${fontSize}px ${fontFamily}`;

  let width = 0;
  let height = 0;
  const lines = text.split("\n");

  for(let i = 0; i < lines.length; i++){
    const metrics = ctx.measureText(lines[i]);
    width = metrics.width > width ? metrics.width : width;
    height += Number(fontSize) * lineScale;
    height += i == lines.length - 1 ? 0 : Number(lineHeight);
  }
  height += Number(fontSize) * (lineScale - 1);

  return new Size(width, height);
}

/************************************************************
 * テキスト画像のBase64生成
 ************************************************************/

export const createBase64Text = (obj: any, defaultText: string = "テキスト") => {
  let base64Text = null;
  if(obj.direction == DirectionEnum.Horizon){
    base64Text = createBase64TextHorizon(obj, defaultText);
  }else if(obj.direction == DirectionEnum.Vertical){
    base64Text = createBase64TextVertical(obj, defaultText);
  }
  return base64Text;
}

/************************************************************
 * 横書きテキスト画像のBase64生成
 ************************************************************/

export const createBase64TextHorizon = (obj: any, defaultText: string) => {
  const text = obj.text ? obj.text : defaultText;
  const canvas = document.createElement('canvas') as HTMLCanvasElement;
  canvas.width = obj.width;
  canvas.height = obj.height;
  const ctx = canvas.getContext('2d');
  const font_family = 'font_family' in obj && obj.font_family ? obj.font_family : "serif";
  ctx.font = `${obj.font_size}px ${font_family}`;
  ctx.fillStyle = obj.color;
  let y = 0;
  const lines = text.split("\n");
  for(let i = 0; i < lines.length; i++){
    y += i == 0 ? Number(obj.font_size) : Number(obj.font_size) * lineScale;
    ctx.fillText(lines[i], 0, y);
    y += Number(obj.line_height);
  }
  return canvas.toDataURL("image/png").replace("data:image/png;base64,", "");
}

/************************************************************
 * 縦書きテキスト画像のBase64生成
 ************************************************************/

export const createBase64TextVertical = (obj: any, defaultText: string) => {

  const text = obj.text ? obj.text : defaultText;
  const letterSpacing = 0;
  const fontFamily = 'font_family' in obj && obj.font_family ? obj.font_family : "serif";
  const textSize = getTextSizeVertical({text: text, fontSize: obj.font_size, lineHeight: obj.line_height, fontFamily: fontFamily});
  const width = textSize.width;
  const height = textSize.height;

  const canvas = document.createElement("canvas");

  // 幅、高さを整数で設定
  canvas.width = Math.ceil(width);
  canvas.height = Math.ceil(height);
  canvas.style.cssText = "margin: 0px; padding: 0px; line-height: 0px";

  const ctx = canvas.getContext("2d");
  ctx.font = `${obj.font_size}px ${fontFamily}`;
  ctx.fillStyle = obj.color;

  const textArray = text.split(/\r\n|\r|\n/);

  // 1行あたりの幅
  const rowWidthPer = width / textArray.length;

  const baseCharSize = getBaseSizeOfSingleChar(obj.font_size, fontFamily);

  const baseYPos = baseCharSize.fontBoundingBoxAscent;

  // 左から画像作成の為、配列の要素数は最大から減算
  for (let rowNo = textArray.length - 1, i = 0; rowNo >= 0; rowNo--, i++) {

    const text = textArray[rowNo];

    const xPos = rowWidthPer * i;

    for (let colNo = 0; colNo < text.length; colNo++) {

      const word = text.charAt(colNo);
      const nextWord = text.charAt(colNo + 1);

      // Y軸位置
      const yPos = baseYPos + ((parseInt(obj.font_size) + letterSpacing) * colNo);

      if (word == "！" || word == "？") {

        /* ** ！？連続表示 ** */

        if (nextWord == "！" || nextWord == "？") {

          ctx.fillText(word, xPos - (obj.font_size * 0.25), yPos);
          ctx.fillText(nextWord, xPos + (obj.font_size * 0.25), yPos);

          // 同一行と列に2文字表示する為、次の文字を表示する為、+1
          colNo = colNo + 1;
        } else {
          ctx.fillText(word, xPos, yPos);
        }
      } else {

        // 回転時 fillText(文字, 上下(数字が小さいほど上), 左右(数字が小さいほど右))
        // 通常時 fillText(文字, 左右(数字が大きいほど右), 上下(数字が大きいほど下))

        if (word.match(/[「『（）＜＞【】〔〕≪≫＜＞～―…：；{}｛｝]/)) {
          ctx.save();
          ctx.setTransform(1, 0, 0, 1, 0, 0);
          ctx.rotate(90 * Math.PI / 180);
          ctx.fillText(word, yPos - obj.font_size * 0.75, -xPos - obj.font_size * 0.12);
          ctx.restore();
        } else if (word.match(/[」』]/)) {
          ctx.save();
          ctx.setTransform(1, 0, 0, 1, 0, 0);
          ctx.rotate(90 * Math.PI / 180);
          ctx.fillText(word, yPos - obj.font_size * 1, -xPos - obj.font_size * 0.12);
          ctx.restore();
        } else if (word.match(/[-=ー＝]/)) {
          ctx.save();
          ctx.setTransform(1, 0, 0, 1, 0, 0);
          ctx.rotate(90 * Math.PI / 180);
          ctx.fillText(word, yPos - obj.font_size * 0.75, -xPos - obj.font_size * 0.2);
          ctx.restore();
        } else if (word.match(/[。]/)) {
          ctx.save();
          ctx.setTransform(1, 0, 0, 1, 0, 0);
          ctx.rotate(90 * Math.PI / 180);
          ctx.fillText(word, yPos - obj.font_size * 0.8, -xPos - obj.font_size * 0.75);
          ctx.restore();
        } else if (word.match(/[、]/)) {
          ctx.fillText(word, xPos + obj.font_size * 0.6 , yPos - obj.font_size * 0.7);
        } else if (word.match(/[A-Za-z0-9ｦ-ｯｱ-ﾝ]/)) {

          const charWidth = ctx.measureText(word).width;

          const adjustXpos = xPos + (obj.font_size / 2) - (charWidth / 2);

          ctx.fillText(word, adjustXpos, yPos);
        } else {
          ctx.fillText(word, xPos, yPos);

          // TODO 「゛」を付ける文字を指定(いらない？)
          // if (nextWord == "゛") {

          // 	/* ** 「゛」は並べて表示 ** */

          // 	ctx.fillText(nextWord, xPos + (obj.font_size * 0.8), yPos);

          // 	// 同一行と列に2文字表示する為、次の文字を表示する為、+1
          // 	colNo = colNo + 1;
          // }
        }
      }
    }
  }

  return canvas.toDataURL("image/png").replace("data:image/png;base64,", "");
}

/************************************************************
 * 縦書きテキスト画像のサイズ取得
 ************************************************************/

export const getTextSizeVertical = ({
  text,
  fontSize,
  lineHeight,
  letterSpacing = 0,
  fontFamily = "serif",
}: GetTextSizeOptions) => {
  
  const charSize = getBaseSizeOfSingleChar(fontSize, fontFamily);
  
  text = text ? text : "クリックして解答を入力してください。";
  const rowCnt = getVerticalRowCnt(text);
	const colCnt = getVerticalColCnt(text);

  const width = (charSize.width + lineHeight) * rowCnt;
	const height = (fontSize + letterSpacing) * colCnt + (fontSize / 32 * 10);;

  return new Size(width, height);
}

/************************************************************
 * 縦書きテキスト用の全角1文字あたりのサイズ取得
 ************************************************************/

export const getBaseSizeOfSingleChar = (fontSize: number, fontFamily: string = "serif") => {
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  ctx.font = `${fontSize}px ${fontFamily}`;

  const char = "あ";
  const charSize = ctx.measureText(char);

  return charSize
}

/************************************************************
 * 縦書きテキストの行数取得
 ************************************************************/

export const getVerticalRowCnt = (text: string) => {

  const textArray = text.split(/\r\n|\r|\n/);
  const rowCnt = textArray.length;

  return rowCnt;
}

/************************************************************
 * 縦書きテキストの列数取得
 ************************************************************/

export const getVerticalColCnt = (text: string) => {

  const textArray = text.split(/\r\n|\r|\n/);
  const colCnt = textArray.reduce((maxCnt, value) => {
    return value.length > maxCnt ? value.length : maxCnt;
  }, 0);

  return colCnt;
}

export class Size {
  width: number
  height: number
  
  constructor(width: number, height: number){
    this.width = width;
    this.height = height;
  }
}

export class Point {
  x: number
  y: number
  
  constructor(x: number, y: number){
    this.x = x;
    this.y = y;
  }
}

/***************************
 * sheet_field.answer_type Enum
 * api側のConstantsと同じ定義にすること
 ***************************/
 export enum AnswerTypeEnum {
  Both = 1,
  Draw = 2,
  Text = 3,
  Choice = 4,
  Image = 5,
}

export interface ComoboxAnswerType {
  value: number
  text: string
}

export function GetComboboxAnswerTypeArray() :ComoboxAnswerType[] {
  const rtn: ComoboxAnswerType[] = [];
  rtn.push({value: AnswerTypeEnum.Both, text: GetAnswerTypeNameByCode(AnswerTypeEnum.Both)});
  rtn.push({value: AnswerTypeEnum.Draw, text: GetAnswerTypeNameByCode(AnswerTypeEnum.Draw)});
  rtn.push({value: AnswerTypeEnum.Text, text: GetAnswerTypeNameByCode(AnswerTypeEnum.Text)});
  rtn.push({value: AnswerTypeEnum.Choice, text: GetAnswerTypeNameByCode(AnswerTypeEnum.Choice)});
  rtn.push({value: AnswerTypeEnum.Image, text: GetAnswerTypeNameByCode(AnswerTypeEnum.Image)});
  return rtn;
}

export function GetAnswerTypeNameByCode(code: number){
  let rtn = "";
  if(code == AnswerTypeEnum.Both){
    rtn = "手書き・テキスト";
  }else if(code == AnswerTypeEnum.Draw){
    rtn = "手書きのみ";
  }else if(code == AnswerTypeEnum.Text){
    rtn = "テキストのみ";
  }else if(code == AnswerTypeEnum.Choice){
    rtn = "選択肢";
  }else if(code == AnswerTypeEnum.Image){
    rtn = "画像";
  }
  return rtn;
}

/**
 * ファイル名から拡張子取得
 * @param fileName 
 * @returns 
 */
export const getFileExtension = (fileName: string) => {
  var fileNameSplitArray = fileName.split('.');

  if(fileNameSplitArray.length == 1){
    return "";
  }else{
    return fileNameSplitArray[fileNameSplitArray.length - 1].toLowerCase();
  }
}

export const groupBy = (xs: any[], key: string) => {
  return xs.reduce((rv, x) => {
    (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
   }, {});
};

export const customAlert = async (bvModal: any, store: any, msg: string) => {
  store.commit("setIsShowingMsgBox", true);
  const result =  await bvModal.msgBoxOk(msg, {autoFocusButton: "ok", id: "msg-box"});
  store.commit("setIsShowingMsgBox", false);
  return result;
}

export const customConfirm = async (bvModal: any, store: any, msg: string, title: string = "確認") => {
  store.commit("setIsShowingMsgBox", true);
  const result =  await bvModal.msgBoxConfirm(msg, {autoFocusButton: "ok", id: "msg-box", title: title});
  store.commit("setIsShowingMsgBox", false);
  return result;
}

export const showToast = (bvToast: any, msg: string, title: string = "処理完了", isError = false) => {
  bvToast.toast(msg, {
    variant: isError ? "denger" : "success",
    title: title,
    autoHideDelay: 3000,
    autoHide: true,
    appendToast: true,
    solid: true,
    toaster: "b-toaster-bottom-right",
  })
}

export const studentSiteLoginCheck = (context: SetupContext) => {
  if(context.root.$store.state.student_code == null){
    if(context.root.$route.fullPath.includes("teacher_site")){
      alert("表示対象の生徒CDが保持されていません。生徒レポート確認画面からやり直してください。");
      context.root.$router.push(`/teacher_site/student_seiseki_list`);
    }else{
      const url = window.location.href;
      const ary = url.split("/");
      const school_prefix_index = ary.indexOf("#") + 1;

      document.cookie = 'access_token=';
      document.cookie = 'smarky_user_id=';
      document.cookie = 'smarky_is_parent=';
      context.root.$store.commit("setCurrentUser", null);
      context.root.$store.commit("setGauthCredentials", null);
      context.root.$store.commit("setStudentCode", null);
      context.root.$store.commit("setStudentName", null);

      if(getCookieValue(document.cookie, "api_kind") == "sso_student_login"){
        alert("認証に失敗しました。一度ブラウザを閉じてから再度アクセスしてください。")
        window.close();
      }else{
        if(ary.length < school_prefix_index + 1 || ary[school_prefix_index] == null || ary[school_prefix_index] == undefined){
          alert("ログイン情報が存在しません。一度ブラウザを閉じてから再度ログインページにアクセスしてください。");
        }else{
          alert("ログイン情報が存在しません。ログイン画面に戻ります。");
          window.location.href = `/#/${ary[school_prefix_index]}/student_site/sign_in`;
        }
      }
    }
    return false;
  }else{
    return true;
  }
}

export const getCookieValue = (cookies: any, key: string) => {
  
  let rtn: string = null;
  const cookiesArray = cookies.split(';');
  for(let c of cookiesArray){
    const cArray = c.split('=');
    if(cArray[0].trim() == key){
      rtn = cArray[1];
    }
  }
  return rtn;
}

export enum DrawModeEnum {
  None = 0,
  FreeLine = 1,
  StraightLine = 2,
  Marker = 3,
  Eraser = 4,
  BracesStart = 5,
  BracesEnd = 6,
  Number = 7,
  Delete = 8,
  Text = 9,
  KeyInput = 11, 
  SeitouClick = 12, 
  GotouClick = 13, 
  TokutenClick = 14, 
  Image = 15,
  ScoreStamp = 16,
}

export enum DirectionEnum {
  Horizon = 1,
  Vertical = 2,
}

export const PreviewImageTypeEnum = Object.freeze({None: 0, Question: 1, Correct: 2, Answer: 3, Movie: 4});

export enum SaitenSortKindEnum {
  No = 1,
  CorrectState = 2,
  FileSize = 3,
}

const adaptor = liteAdaptor();
RegisterHTMLHandler(adaptor);
const tex = new TeX({packages: AllPackages});
const svg = new SVG({fontCache: 'none'});
const mathDocument = mathjax.document('', {InputJax: tex, OutputJax: svg});

export const convertSvgElementByLaTex = (laTex: string): string => {
  const node = mathDocument.convert(laTex, {display: true});
  return adaptor.outerHTML(node);
};

/***************************
 * 文字認識の種別 Enum
 ***************************/
export enum RecogTypeEnum {
  SingleNumber = 1,
  SingleAlpha = 2,
  SingleKana = 3,
  SingleHira = 4,
  SingleKanNumber = 5,
  SingleYesNo = 6,
  EnglishWord = 7,
  EnglishSentence = 8,
  Math = 9,
}

export interface ComoboxRecogType {
  value: number
  text: string
}

export function GetComboboxRecogTypeArray() :ComoboxRecogType[] {
  const rtn: ComoboxRecogType[] = [];
  rtn.push({value: RecogTypeEnum.SingleNumber, text: GetRecogTypeNameByCode(RecogTypeEnum.SingleNumber)});
  rtn.push({value: RecogTypeEnum.SingleAlpha, text: GetRecogTypeNameByCode(RecogTypeEnum.SingleAlpha)});
  rtn.push({value: RecogTypeEnum.SingleKana, text: GetRecogTypeNameByCode(RecogTypeEnum.SingleKana)});
  rtn.push({value: RecogTypeEnum.SingleHira, text: GetRecogTypeNameByCode(RecogTypeEnum.SingleHira)});
  rtn.push({value: RecogTypeEnum.SingleKanNumber, text: GetRecogTypeNameByCode(RecogTypeEnum.SingleKanNumber)});
  rtn.push({value: RecogTypeEnum.SingleYesNo, text: GetRecogTypeNameByCode(RecogTypeEnum.SingleYesNo)});
  rtn.push({value: RecogTypeEnum.EnglishWord, text: GetRecogTypeNameByCode(RecogTypeEnum.EnglishWord)});
  // rtn.push({value: RecogTypeEnum.EnglishSentence, text: GetRecogTypeNameByCode(RecogTypeEnum.EnglishSentence)});
  rtn.push({value: RecogTypeEnum.Math, text: GetRecogTypeNameByCode(RecogTypeEnum.Math)});
  return rtn;
}

export function GetRecogTypeNameByCode(code: number){
  let rtn = "";
  if(code == RecogTypeEnum.SingleNumber){
    rtn = "数字1文字（0～9）";
  }else if(code == RecogTypeEnum.SingleAlpha){
    rtn = "アルファベット1文字（A～F, a～f）";
  }else if(code == RecogTypeEnum.SingleKana){
    rtn = "カタカナ1文字（ア～チ）";
  }else if(code == RecogTypeEnum.SingleHira){
    rtn = "ひらがな1文字（あ～こ）";
  }else if(code == RecogTypeEnum.SingleKanNumber){
    rtn = "漢数字1文字（一～九）";
  }else if(code == RecogTypeEnum.SingleYesNo){
    rtn = "マルバツ1文字（○・×）";
  }else if(code == RecogTypeEnum.EnglishWord){
    rtn = "英単語";
  }else if(code == RecogTypeEnum.EnglishSentence){
    rtn = "英文";
  }else if(code == RecogTypeEnum.Math){
    rtn = "数式";
  }
  return rtn;
}

export function IsSingleCharRecog(code: number){
  return [RecogTypeEnum.SingleNumber, RecogTypeEnum.SingleAlpha, RecogTypeEnum.SingleKana, RecogTypeEnum.SingleHira, RecogTypeEnum.SingleKanNumber, RecogTypeEnum.SingleYesNo].includes(code);
}

export interface ComoboxRecogChar {
  value: number
  text: string
}

export function GetComboboxRecogCharArray(recog_type: number){
  let rtn: ComoboxRecogChar[] = [];
  
  if(recog_type == RecogTypeEnum.SingleNumber){
    rtn.push({value: 0, text: "0"});
    rtn.push({value: 1, text: "1"});
    rtn.push({value: 2, text: "2"});
    rtn.push({value: 3, text: "3"});
    rtn.push({value: 4, text: "4"});
    rtn.push({value: 5, text: "5"});
    rtn.push({value: 6, text: "6"});
    rtn.push({value: 7, text: "7"});
    rtn.push({value: 8, text: "8"});
    rtn.push({value: 9, text: "9"});
  }else if(recog_type == RecogTypeEnum.SingleAlpha){
    rtn.push({value: 0, text: "Aa"});
    rtn.push({value: 1, text: "Bb"});
    rtn.push({value: 2, text: "Cc"});
    rtn.push({value: 3, text: "Dd"});
    rtn.push({value: 4, text: "Ee"});
    rtn.push({value: 5, text: "Ff"});
  }else if(recog_type == RecogTypeEnum.SingleKana){
    rtn.push({value: 0, text: "ア"});
    rtn.push({value: 1, text: "イ"});
    rtn.push({value: 2, text: "ウ"});
    rtn.push({value: 3, text: "エ"});
    rtn.push({value: 4, text: "オ"});
    rtn.push({value: 5, text: "カ"});
    rtn.push({value: 6, text: "キ"});
    rtn.push({value: 7, text: "ク"});
    rtn.push({value: 8, text: "ケ"});
    rtn.push({value: 9, text: "コ"});
    rtn.push({value: 10, text: "サ"});
    rtn.push({value: 11, text: "シ"});
    rtn.push({value: 12, text: "ス"});
    rtn.push({value: 13, text: "セ"});
    rtn.push({value: 14, text: "ソ"});
    rtn.push({value: 15, text: "タ"});
    rtn.push({value: 16, text: "チ"});
  }else if(recog_type == RecogTypeEnum.SingleHira){
    rtn.push({value: 0, text: "あ"});
    rtn.push({value: 1, text: "い"});
    rtn.push({value: 2, text: "う"});
    rtn.push({value: 3, text: "え"});
    rtn.push({value: 4, text: "お"});
    rtn.push({value: 5, text: "か"});
    rtn.push({value: 6, text: "き"});
    rtn.push({value: 7, text: "く"});
    rtn.push({value: 8, text: "け"});
    rtn.push({value: 9, text: "こ"});
  }else if(recog_type == RecogTypeEnum.SingleKanNumber){
    rtn.push({value: 0, text: "二"});
    rtn.push({value: 1, text: "三"});
    rtn.push({value: 2, text: "四"});
    rtn.push({value: 3, text: "五"});
    rtn.push({value: 4, text: "六"});
    rtn.push({value: 5, text: "七"});
    rtn.push({value: 6, text: "八"});
    rtn.push({value: 7, text: "九"});
  }else if(recog_type == RecogTypeEnum.SingleYesNo){
    rtn.push({value: 0, text: "o"});
    rtn.push({value: 1, text: "x"});
  }

  console.log("あ");

  return rtn;
}

export const getCorrectText = (recog_type: number, text: string) => {
  if(text != null && recog_type == RecogTypeEnum.SingleAlpha){
    if(["A", "a"].includes(text)){
      return "Aa";
    }else if(["B", "b"].includes(text)){
      return "Bb";
    }else if(["C", "c"].includes(text)){
      return "Cc";
    }else if(["D", "d"].includes(text)){
      return "Dd";
    }else if(["E", "e"].includes(text)){
      return "Ee";
    }else if(["F", "f"].includes(text)){
      return "Ff";
    }
  }else{
    return text;
  }
}

/***************************
 * ショートカットキーが使用可能か判定
 * input type="text" or input type="number" or textareaがフォーカスされている場合
 * 入力を優先させるため無効と判定する
 ***************************/

export const isShortcutKeyEnable = (document: Document) => {
  if (document.activeElement instanceof HTMLTextAreaElement ||
    (document.activeElement instanceof HTMLInputElement && ["text", "number"].includes(document.activeElement.type))) {
    return false;
  }else{
    return true;
  }
}

/***************************
 * 文字列とフォントサイズから文字列の横幅の概算を返却
 ***************************/

export const calculateTextWidth = (text: string, zenkakuCharWith: number = 14) => {
  const hankakuCharWidth = 11;
  let width = 0;
  for (const char of text) {
    // 全角文字か半角文字かを判定して概算幅を加算
    if (char.match(/[^\x01-\x7E\uFF61-\uFF9F]/)) {
      width += zenkakuCharWith;
    } else {
      width += hankakuCharWidth;
    }
  }
  return width;
}

export enum CorrectImagePublishRangeEnum {
  Passed = 1,
  Submitted = 2,
  All = 3,
}

export enum CorrectImagePublishTriggerEnum {
  ResultPublished = 1,
  Unpublished = 2,
}

export enum ToolbarPositionEnum {
  None = 0,
  Top = 1,
  Bottom = 2,
  Left = 3,
  Right = 4,
}

export enum ToolbarPositionNameEnum {
  Top = "上",
  Bottom = "下",
  Left = "左",
  Right = "右",
}

export interface ComoboxToolbarPosition {
  value: number
  text: string
}

export function GetComboboxToolbarPositionArray() :ComoboxToolbarPosition[] {
  const rtn: ComoboxToolbarPosition[] = [];
  // rtn.push({value: ToolbarPositionEnum.Top, text: ToolbarPositionNameEnum.Top});
  rtn.push({value: ToolbarPositionEnum.Bottom, text: ToolbarPositionNameEnum.Bottom});
  rtn.push({value: ToolbarPositionEnum.Left, text: ToolbarPositionNameEnum.Left});
  rtn.push({value: ToolbarPositionEnum.Right, text: ToolbarPositionNameEnum.Right});
  return rtn;
}
